import React from 'react';
import { Quote } from 'lucide-react';
import { useInView } from '../hooks/useInView';
const quotes = ['El sueldo que tenés hoy es suficiente. Solo necesitás un sistema que lo respete.', 'Nadie se hizo rico gastando menos. Pero muchos se arruinaron sin un orden.', 'El presupuesto tradicional fue diseñado para hacerte fracasar. Este no.', 'Dejar de llegar justo no requiere sacrificio. Requiere secuencia.', 'Tu cuenta bancaria es el reflejo de tu sistema, no de tu esfuerzo.', 'La diferencia entre ahorro y quiebre es el orden en que movés el dinero.', 'Cada mes que pasa sin sistema es un mes de riqueza que perdiste para siempre.', 'No necesitás un segundo sueldo. Necesitás un primer sistema.', 'El dinero no desapareció. Simplemente nunca tuvo a dónde ir.', 'Hoy podés seguir esperando que sobre algo. O podés cambiar el sistema.'];
export function OneLiners() {
  const {
    ref,
    isVisible
  } = useInView();
  return <section className="py-24 px-4 border-y border-gray-900 bg-[#0A0A0A]" data-id="element-144">
      <div className="max-w-6xl mx-auto" data-id="element-145">
        <div ref={ref} className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-8" data-id="element-146">
          {quotes.map((quote, index) => <div key={index} className={`flex gap-4 ${isVisible ? `anim-fade-up anim-delay-${Math.min(index + 1, 9)}` : 'anim-hidden'}`} data-id="element-147">
              <Quote className="w-6 h-6 text-gold-500/30 shrink-0 rotate-180 mt-1" data-id="element-148" />
              <p className="text-lg text-gray-400 font-serif italic leading-relaxed" data-id="element-149">
                "{quote}"
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}